var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4634 2.41029C17.7891 2.6662 17.8456 3.13769 17.5897 3.4634L12.9538 9.36367L16.1618 13.4465C16.7122 13.1612 17.3373 13.0001 18 13.0001C20.2091 13.0001 22 14.7909 22 17.0001C22 19.2092 20.2091 21.0001 18 21.0001C15.7909 21.0001 14 19.2092 14 17.0001C14 15.995 14.3707 15.0765 14.9828 14.3739L12 10.5776L9.01723 14.3739C9.62933 15.0765 10 15.995 10 17.0001C10 19.2092 8.20914 21.0001 6 21.0001C3.79086 21.0001 2 19.2092 2 17.0001C2 14.7909 3.79086 13.0001 6 13.0001C6.66275 13.0001 7.28785 13.1612 7.83824 13.4465L11.0462 9.36367L6.41026 3.4634C6.15435 3.13769 6.21093 2.6662 6.53663 2.41029C6.86234 2.15438 7.33383 2.21096 7.58974 2.53666L12 8.14972L16.4103 2.53666C16.6662 2.21096 17.1377 2.15438 17.4634 2.41029Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCut);
export default __webpack_public_path__ + "static/media/cut.3045b65d7725f0c2c1d3f098af878ec1.svg";
export { ForwardRef as ReactComponent };